const proxyList = () => import("@/pages/proxy/list/index.vue");
const proxyForm = () => import("@/pages/proxy/list/form.vue");
const proxyDetail = () => import("@/pages/proxy/list/detail.vue");

export default [
    {
        path: "/proxy/list",
        component: proxyList,
        meta: [
            {
                name: "代理管理",
                activeRoute: "/proxy/manage",
            },
            {
                name: "代理员列表",
                activeRoute: "/proxy/list",
            },
        ],
    },
    {
        path: "/proxy/list/form",
        component: proxyForm,
        meta: [
            {
                name: "代理管理",
                activeRoute: "/proxy/manage",
            },
            {
                name: "新增/编辑代理员",
                activeRoute: "/proxy/list",
            },
        ],
    },
    {
        path: "/proxy/list/detail",
        component: proxyDetail,
        meta: [
            {
                name: "代理管理",
                activeRoute: "/proxy/manage",
            },
            {
                name: "代理员详情",
                activeRoute: "/proxy/list",
            },
        ],
    },
];
